import {
  useNavigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom"

let globalNavigate: any = null

export const setGlobalNavigate = (nav: any) => {
  globalNavigate = nav
}

export const Router = {
  push: (url: string) => {
    if (globalNavigate) {
      globalNavigate(url)
    } else {
      window.location.href = url
    }
    return Promise.resolve(true)
  },
  replace: (url: string) => {
    if (globalNavigate) {
      globalNavigate(url, { replace: true })
    } else {
      window.location.replace(url)
    }
    return Promise.resolve(true)
  },
  back: () => {
    if (globalNavigate) {
      globalNavigate(-1)
    } else {
      window.history.back()
    }
  },
}

export function useRouter() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const [searchParams] = useSearchParams()

  // Extract query params from URL search
  const query: Record<string, string> = { ...params }
  searchParams.forEach((value, key) => {
    query[key] = value
  })

  return {
    pathname: location.pathname,
    query,
    isReady: true,
    push: (url: string) => {
      navigate(url)
      return Promise.resolve(true)
    },
    replace: (url: string) => {
      navigate(url, { replace: true })
      return Promise.resolve(true)
    },
    back: () => navigate(-1),
    reload: () => window.location.reload(),
  }
}

export default Router
